/* --------------------------------------------------------------
 * Questlog Konfigurator-PDP: Formular-Logik
 * (Neubau, Claude 22.10.2026; ersetzt das Inline-jQuery aus
 * snippets/product__form_konfigurator.liquid)
 *
 * Vertrag siehe PDP-SEITENLEISTE.md. Insbesondere muessen gleich bleiben:
 *   - die Konfigurator-Adresse (Reihenfolge, Schreibweise, keine Kodierung),
 *   - die Feldnamen option-0/1/2, properties[Laser-Cutting],
 *     properties[Beschriftung],
 *   - das normale Absenden mit Seitenwechsel auf /cart (die Gravur wird
 *     erst dort hinzugefuegt, siehe assets/questlog.js).
 *
 * Kaufknopf gesperrt (updateBuyState), wenn
 *   - die Gravur angehakt, aber kein Text eingegeben ist (wie bisher, stand
 *     als Inline-Skript setDisabled in der Section), oder
 *   - ein Gehaeuse gewaehlt ist, das im Theme-Editor als nicht verfuegbar
 *     markiert ist. Bewusste Abweichung vom alten Stand: Dieser Hinweis
 *     "Aktuell ist ... nicht lieferbar" erschien dort nie (Syntaxfehler).
 * -------------------------------------------------------------- */
(function () {
  var root = document.querySelector('[data-ql-pdp]');
  if (!root) return;

  var form = root.querySelector('form[action*="/cart/add"]');
  var iframe = document.getElementById('config');
  var gravur = document.getElementById('questlog-laser-cutting');
  var label = document.getElementById('label');
  var labelBox = document.getElementById('label-container');
  var notice = root.querySelector('#option-product-avaiable-notice');
  var buyBtn = form ? form.querySelector('.ql-submit-btn') : null;

  // Startwerte wie im alten Code
  var state = {
    label: '',
    wood: 'kirsche',
    bandColor: '#941c0c',
    boxColor: '#a0a0a0',
    hasLabel: false
  };

  function toKey(c) {
    return String(c).toLowerCase().replace(/ /g, '_');
  }

  function updateIframe() {
    var title = root.getAttribute('data-handle') || '';
    if (title.indexOf('zzz-') === 0) title = title.substring(4);
    title = title.trim().toLowerCase();
    var address = 'https://konfigurator.questlog.eu/iframe.html#country=' + title +
      '&holzart=' + state.wood +
      '&band=' + state.bandColor +
      '&gehäuse=' + state.boxColor +
      '&text=' + state.label +
      '&hasLabel=' + state.hasLabel;
    if (iframe) iframe.setAttribute('src', address);
  }

  /* --- Gravur-Feld auf- und zuklappen (statt jQuery slideDown/slideUp) --- */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function slide(el, open) {
    if (!el) return;
    var isOpen = el.style.display !== 'none' && getComputedStyle(el).display !== 'none';
    if (open === isOpen) return;
    if (reduceMotion) {
      el.style.display = open ? '' : 'none';
      return;
    }
    el.style.overflow = 'hidden';
    if (open) {
      el.style.display = '';
      var h = el.scrollHeight;
      el.style.height = '0px';
      el.getBoundingClientRect();
      el.style.transition = 'height .4s ease';
      el.style.height = h + 'px';
    } else {
      el.style.height = el.scrollHeight + 'px';
      el.getBoundingClientRect();
      el.style.transition = 'height .4s ease';
      el.style.height = '0px';
    }
    var done = function () {
      el.removeEventListener('transitionend', done);
      el.style.transition = '';
      el.style.height = '';
      el.style.overflow = '';
      if (!open) el.style.display = 'none';
    };
    el.addEventListener('transitionend', done);
    setTimeout(done, 500);
  }

  /* --- Kaufknopf sperren: Gravur ohne Text, Gehaeuse nicht lieferbar --- */
  function unavailableOption() {
    var checked = root.querySelectorAll('[data-variant-option-value]:checked');
    for (var i = 0; i < checked.length; i++) {
      if (checked[i].getAttribute('data-option-product-avaiable') === 'false') return checked[i];
    }
    return null;
  }

  function gravurMissing() {
    return !!(gravur && label && gravur.checked && !label.value);
  }

  function updateBuyState() {
    if (!buyBtn) return;
    var blocked = unavailableOption();
    if (notice) {
      if (blocked) {
        notice.textContent = 'Aktuell ist ' + blocked.getAttribute('aria-label') + ' nicht lieferbar.';
        notice.style.display = 'block';
      } else {
        notice.textContent = '';
        notice.style.display = '';
      }
    }
    if (blocked) buyBtn.setAttribute('data-ql-unavailable', '');
    else buyBtn.removeAttribute('data-ql-unavailable');
    buyBtn.disabled = !!blocked || gravurMissing();
  }

  /* --- Ereignisse --- */
  if (form) {
    form.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.type !== 'radio') return;
      if (t.name === 'option-0') { state.wood = t.value.toLowerCase(); updateIframe(); }
      else if (t.name === 'option-1') { state.boxColor = toKey(t.value); updateIframe(); }
      else if (t.name === 'option-2') { state.bandColor = toKey(t.value); updateIframe(); }
      updateBuyState();
    });

    // Sperre auch dann, wenn ein anderes Skript den Knopf wieder freigibt
    form.addEventListener('submit', function (e) {
      if (buyBtn && (buyBtn.hasAttribute('data-ql-unavailable') || gravurMissing())) e.preventDefault();
    });
  }

  if (label) {
    // keyup wie bisher; input zusaetzlich, damit auch Einfuegen per Maus und
    // Autokorrektur auf dem Handy die Vorschau erreichen
    var onLabel = function () {
      if (state.label === label.value) return;
      state.label = label.value;
      updateIframe();
    };
    label.addEventListener('keyup', onLabel);
    label.addEventListener('input', onLabel);
    label.addEventListener('input', updateBuyState);
  }

  if (gravur) {
    gravur.addEventListener('change', function () {
      slide(labelBox, gravur.checked);
      state.hasLabel = gravur.checked;
      updateIframe();
      updateBuyState();
    });
  }

  /* --- Liefer-Hinweis mit Ablaufdatum: Liquid blendet ihn serverseitig aus;
     falls eine zwischengespeicherte Seite ihn noch enthaelt, hier nach Ortszeit --- */
  var dated = root.querySelectorAll('[data-ql-until]');
  if (dated.length) {
    var now = new Date();
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var todayIso = now.getFullYear() + '-' + pad(now.getMonth() + 1) + '-' + pad(now.getDate());
    for (var d = 0; d < dated.length; d++) {
      if (todayIso > dated[d].getAttribute('data-ql-until')) dated[d].hidden = true;
    }
  }

  /* --- Start: wie window.onload im alten Code --- */
  function init() {
    var defaultData = (root.getAttribute('data-default-title') || '').split(' / ');

    var stored = null;
    try { stored = window.localStorage.getItem('questlog'); } catch (e) { stored = null; }

    if (stored !== null) {
      try { window.localStorage.removeItem('questlog'); } catch (e) {}
      var params = stored.split(',').map(function (p) { return p.split('='); });
      if (params[0] && params[0][1] === 'Ja') {
        var text = params[1] ? params[1][1] : undefined;
        state.hasLabel = true;
        state.label = text;
        if (gravur) gravur.checked = true;
        if (label) label.value = text === undefined ? '' : text;
        slide(labelBox, true);
      }
    } else {
      if (gravur && gravur.checked) {
        state.hasLabel = true;
        slide(labelBox, true);
      }
      if (label && label.value) state.label = label.value;
    }

    state.wood = defaultData[0] ? defaultData[0].toLowerCase() : 'kirsche';
    state.bandColor = toKey(defaultData[2] || 'default_color');
    state.boxColor = toKey(defaultData[1] || 'default_color');

    updateIframe();
    updateBuyState();
  }

  if (document.readyState === 'complete') init();
  else window.addEventListener('load', init);
})();
